import { render, staticRenderFns } from "./commercialCompanyAudit.vue?vue&type=template&id=21772ace&scoped=true"
import script from "./commercialCompanyAudit.vue?vue&type=script&lang=js"
export * from "./commercialCompanyAudit.vue?vue&type=script&lang=js"
import style0 from "./commercialCompanyAudit.vue?vue&type=style&index=0&id=21772ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21772ace",
  null
  
)

export default component.exports